import { PermissionBit } from "../api";

export function hasPermission(
  permissions: PermissionBit[],
  bit: PermissionBit,
): boolean {
  return permissions.includes(bit);
}

export function hasAdminAccess(permissions: PermissionBit[]): boolean {
  return hasPermission(permissions, PermissionBit.GROUP_ADMIN_ROUTERS);
}

export function hasMonitoringAccess(permissions: PermissionBit[]): boolean {
  return hasPermission(permissions, PermissionBit.GROUP_MONITORING_ROUTERS);
}

export function hasMedicalAccess(permissions: PermissionBit[]): boolean {
  return hasPermission(permissions, PermissionBit.GROUP_MEDICAL_ROUTERS);
}

export function hasClinicalStudiesAccess(
  permissions: PermissionBit[],
): boolean {
  return hasPermission(permissions, PermissionBit.CLINICAL_STUDIES);
}

export function hasAIChatAccess(permissions: PermissionBit[]): boolean {
  return hasPermission(permissions, PermissionBit.ACCESS_AI_CHAT);
}
